@if (isOpen) {
  <div class="form-popup-backdrop form-popup-fade-in" (click)="onBackdropClick($event)">
    <div class="form-popup-modal form-popup-scale-in" (click)="$event.stopPropagation()">
      @if (header) {
        <tidy-row [ngClass]="!descriptionText ? 'extra-bottom-padding' : ''">
          <tidy-text [header]="header" />
        </tidy-row>
      }
      @if (descriptionText) {
        <tidy-row class="extra-bottom-padding">
          <tidy-text [body]="descriptionText" />
        </tidy-row>
      }
      @if (formType === 'custom') {
        <ng-content />
      } @else {
        <tidy-row>
          <form [formGroup]="form" novalidate>
            @if (formType === 'input') {
              <tidy-input
                formControlName="value"
                [form]="form.controls.value"
                [label]="label"
                [icon]="icon"
                [placeholder]="placeholder" />
            }
            @if (formType === 'select') {
              <tidy-select
                formControlName="value"
                [form]="form.controls.value"
                [label]="label"
                [items]="items"
                [icon]="icon" />
            }
          </form>
        </tidy-row>
      }
      <div class="form-popup-buttons">
        <tidy-button
          [text]="cancelText"
          class="secondary"
          [smallText]="true"
          [action]="onCancel" />
        <tidy-button
          [text]="saveText"
          class="primary"
          [smallText]="true"
          [action]="onSave" />
      </div>
    </div>
  </div>
}
